import { gql } from '@apollo/client';

/** 轻量查询：仅包牌基础信息，不拉订单列表，用于PDA装包扫描等高频场景 */
export const GET_BAG_BASIC_INFO_BY_NUMBER = gql`
  query GetBagBasicInfoByNumber($bagNumber: String!) {
    getBagBasicInfoByNumber(bagNumber: $bagNumber) {
      id
      bagNumber
      businessType
      fromLocation
      nextStop
      sortingCode
      status
      carrierCode
      printType
      warehouseId
    }
  }
`;

export interface BagBasicInfoType {
  id: string;
  bagNumber: string;
  businessType: number | null;
  fromLocation: string | null;
  nextStop: string | null;
  sortingCode: string | null;
  status: number;
  carrierCode: number | null;
  /** 打印模板类型 1-SwiftX 2-TT */
  printType: number | null;
  /** 创建站点ID */
  warehouseId: number | null;
}

/** 尾程商选项，与后端 CarrierOptionType 对应 */
export interface CarrierOptionType {
  value: number;
  name: string;
}

/** 获取尾程商选项列表（WarehouseQuery.getAllCarrierOptions） */
export const GET_ALL_CARRIER_OPTIONS = gql`
  query GetAllCarrierOptions {
    getAllCarrierOptions {
      value
      name
    }
  }
`;

export interface GetAllCarrierOptionsResponse {
  getAllCarrierOptions: CarrierOptionType[];
}

/** 0-未使用 1-已使用 2-已废弃 3-已使用(尾程交接) */
export const BAG_STATUS_DISCARDED = 2;
export const BAG_STATUS_HANDOVER = 3;

export interface GetBagBasicInfoByNumberResponse {
  getBagBasicInfoByNumber: BagBasicInfoType | null;
}

export interface GetBagBasicInfoByNumberVariables {
  bagNumber: string;
}

/** 装包扫描候选包牌：与后端 BaggingScanCandidateBagInput 对应 */
export interface BaggingScanCandidateBagInput {
  bagNumber: string;
  sortingCode: string;
  carrierCode?: number | null;
}

/** 装包扫描：后端匹配段码，返回匹配到的包牌号 */
export const HANDLE_WHS_BAGGING_SCAN_EVENT = gql`
  mutation HandleWhsBaggingScanEvent($trackingNumber: String!, $candidateBags: [BaggingScanCandidateBagInput!]!) {
    matchedBagNumber: handleWhsBaggingScanEvent(trackingNumber: $trackingNumber, candidateBags: $candidateBags)
  }
`;

export interface HandleWhsBaggingScanEventVariables {
  trackingNumber: string;
  candidateBags: BaggingScanCandidateBagInput[];
}
